/**
 * @module deliveryMethods
 * @description A list of deliveryMethods
 */

export const deliveryMethods = [
	'split',
	'delivery',
	'counter',
	'download',
	'table',
	'virtual',
] as const;
export type DeliveryMethods = (typeof deliveryMethods)[number];
